/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import BootstrapMenuBar from "./components/menu/BootstrapMenuBar";
import TSExpert from "./components/ts-expert/TSExpert";
import LiveList from "./components/LiveList";
import Dados from "./components/Dados";
import LiveListMatrix from "./components/LiveListMatrix";
import Oscilloscope from "./components/Oscilloscope";
import BarGraph from "./components/BarGraph";
import EventLog from "./components/EventLog";
import Report from "./components/login-config/Report.js";
import Configuration from "./components/login-config/Configuration";
import Login from "./components/login-config/Login";
import LoginHandler from "./components/login-config/LoginHandler";
import ChangeLogin from "./components/login-config/ChangeLogin";
import EditTags from "./components/login-config/EditTags";
import WLANConfig from "./components/login-config/WLANConfig";
import EthernetConfig from "./components/login-config/EthernetConfig";
import TsExpertConfig from "./components/login-config/TsExpertConfig";
import ActiveChannels from "./components/login-config/ActiveChannels.js";

import Constants from "./components/utilities/Constants";

class App extends Component {

  // ----------------- Lifecycle Methods ----------------
  componentDidMount = async () => {
    if (localStorage.getItem(Constants.LOCAL_STORAGE_KEY) === null) {
      let language = await fetch(Constants.REQUEST_IP_ADDRESS + "language", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.language);

      localStorage.setItem(Constants.LOCAL_STORAGE_KEY, language);
      window.location.reload();
    }
  }
  
  render() {
    return (
      <Router basename={process.env.PUBLIC_URL}>
        <div className="App">
          <BootstrapMenuBar />
          <Redirect exact from="" to="/" />
          <Route exact path="/" component={TSExpert} />
          <Route path="/live-list" component={LiveList} />
          <Route path="/dados" component={Dados} />
          <Route path="/live-list-matrix" component={LiveListMatrix} />
          <Route path="/oscilloscope" component={Oscilloscope} />
          <Route path="/bar-graph" component={BarGraph} />
          <Route path="/log" component={EventLog} />
          <Route path="/config" component={Configuration} />
          <Route path="/login" component={Login} />
          <Route path="/login-handler" component={LoginHandler} />
          <Route path="/change-login" component={ChangeLogin} />
          <Route path="/tags" component={EditTags} />
          <Route path="/report" component={Report} />
          <Route path="/wlan-config" component={WLANConfig} />
          <Route path="/ethernet-config" component={EthernetConfig} />
          <Route path="/ts-expert-config" component={TsExpertConfig} />
          <Route path="/active-channels" component={ActiveChannels} />
        </div>
      </Router>
    );
  }
}

export default App;
